interface ToggleProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Toggle({
  label,
  description,
  checked,
  onChange,
  disabled
}: ToggleProps) {
  return (
    <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
      <div className="flex-1">
        <span className="font-medium text-slate-900">{label}</span>
        {description && <p className="text-sm text-slate-500 mt-0.5">{description}</p>}
      </div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <div className={`
          w-11 h-6 bg-slate-200 rounded-full peer
          peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300
          peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
          peer-checked:after:border-white
          after:content-[''] after:absolute after:top-[2px] after:start-[2px]
          after:bg-white after:border-slate-300 after:border after:rounded-full
          after:h-5 after:w-5 after:transition-all
          peer-checked:bg-teal-500
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `} />
      </label>
    </div>
  );
}
